module.exports = __webpack_public_path__ + "img/leaf_4.1fa29be6.png";